import { $api } from "../../../../services/request.config";
import { getDelegates } from "../getDelegates.action";

export const getAviableRequestTypesThunkAction = (data) => async(dispatch) => {
    try {
        const response = await $api(`v1/requests/types/${data.id}/validate`);
        if (response.status === 200) {
            dispatch(getDelegates({delegators: response.data.delegators.length ? response.data.delegators.map((el)=> {
                return {
                    ...el,
                    id: el.pid,
                    name: `${el.fullName} `, //- ${el.jobTitle}
                };
            }) : []}));
        }
        console.log("DATAAAA",response.data);
    }catch (error) {
        console.log(error);
        data && data.navigate && data.navigate("/main/hr-services/requests");
    }
};
